export { default } from "./useRemoveTeacherSchool";
